<!--
  ~ Copyright (c) 2022.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="jumbotron">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-4 text-justify">
        <h3 i18n="@@wantDo">What do you want to do ?</h3>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 text-justify">
        <p><strong i18n="@@caution">Caution</strong>, <span i18n="@@thirdPartiesAllowed">
        your login allows you to access all the following accounts
      </span>:
        </p>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-1 text-justify">
        <app-display-third-parties (updated)="loadPendingRemovals($event)"></app-display-third-parties>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-justify">
        <p i18n="@@beCarefulOnRequests">
          Thank you for being vigilant to the chosen account during your requests or searches.
        </p>
      </div>
    </div>
  </div>

  <!-- TODO START remove me when transfer to Secanim is finished  -->
  <app-provalt-banner-collectable></app-provalt-banner-collectable>
  <!-- TODO End remove me when transfer to Secanim is finished  -->

  <div class="ibox">
    <div class="ibox-body">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-2 mb-sm-2 mb-md-0 mb-lg-0 mb-xl-0">
          <button routerLink="/removal" class="btn btn-info btn-block btn-lg pt-5 pb-5">
            <span i18n="@@makeRequest">Make a request</span>
            <br/>
            <span i18n="@@removalOnline">of removal online</span>
          </button>
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <button routerLink="/history" class="btn btn-info btn-block btn-lg pt-5 pb-5">
            <span i18n="@@history">History</span>
            <br/>
            <span i18n="@@removalVouchers">Removal vouchers</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="ibox" *ngIf="0 < removals?.length">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@pendingRemovals">Removals Pending</div>
    </div>

    <div class="ibox-body">
      <div class="row mb-2" *ngFor="let r of removals">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <app-adapter-removal-pending [data]="r"></app-adapter-removal-pending>
        </div>
      </div>
    </div>
  </div>
</div>

